import { Pipe, PipeTransform } from '@angular/core';

import * as COUNTRIES from '../data/countries.json';

@Pipe({
  name: 'countryCode',
  standalone: false
})
export class CountryCodePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    // Ensure the value is a string before calling getCountryFromCode
    if (typeof value === 'string') {
      const country = this.getCountryFromCode(value);
      return country || value;
    }
    return null;
  }

  /**
   * @description - get a country based on it's ISO code
   * @param code - the country's ISO code e.g. FR for France
   */
  getCountryFromCode(code: string): string | null {
    let found = null;

    try {
      found = COUNTRIES[code.toUpperCase()];
    } catch (error) {
      console.error(error);
    }

    return found;
  }
}
